


// Generated from io.spcfy.orders.artifactpipelines.SpinAlgorithm

export type SpinAlgorithmKey =
  "SPCFY" |
  "SWARM" |
  "VSEARCH";


export interface SpinAlgorithmDTO {
  key: SpinAlgorithmKey;
  label: string;    
}


export const SpinAlgorithms: Record<SpinAlgorithmKey, SpinAlgorithmDTO> = {
  SPCFY: { key: "SPCFY", label: "SPCFY" },
  SWARM: { key: "SWARM", label: "SWARM" },
  VSEARCH: { key: "VSEARCH", label: "VSEARCH" }
};
